import React from "react";
import { Outlet } from "react-router-dom";

const RoomsLayout = () => {
  return <Outlet />;
};

export default RoomsLayout;
